import {
  QUERY_DISTRIBUTIONS,
  useSearchDistributions,
  useSearchNft,
  VARIABLES_DISTRIBUTIONS,
} from '@dapperlabs/core-fe';
import { useEffect, useMemo, useState } from 'react';
import { FS } from 'src/general/constants/finiteStates';
import { useQueryStates } from 'src/general/hooks';
import { mergePackDistributions } from 'src/general/utils/mergePackDistributions';
import {
  SEARCH_PACK_NFT_BY_OWNER_ADDRESS,
  searchPackNftByOwnerAddress,
} from 'src/modules/Queries/searchNft';

const PAGE_SIZE = 20;

export const usePackList = (flowAddress) => {
  const [page, setPage] = useState(1);
  const [distIdsPage, setDistIdsPage] = useState(0);
  const [isDone, setIsDone] = useState(false);
  const [packs, setPacks] = useState([]);
  const [advancePage, setAdvancePage] = useState(false);

  const { moments: packList, state: packListState } = useSearchNft({
    aggregationResponseType: 'searchPackNft',
    query: SEARCH_PACK_NFT_BY_OWNER_ADDRESS(),
    variables: searchPackNftByOwnerAddress(flowAddress),
  });

  const numPages = Math.ceil(packList.length / PAGE_SIZE);

  // Extract list of distributionIds so we can query for distributions
  const distributionIds = useMemo(
    () =>
      packList && packList.length > 0
        ? packList.map((packNft) => packNft['dist_id'].toString())
        : [],
    [packList],
  );

  const distIdsToSearch = useMemo(
    () =>
      distributionIds.slice(
        distIdsPage * PAGE_SIZE,
        (distIdsPage + 1) * PAGE_SIZE,
      ),
    [distIdsPage, distributionIds],
  );

  const { distributions, state: distributionState } = useSearchDistributions({
    options: {
      context: {
        clientName: 'platformAPI',
      },
      errorPolicy: 'ignore',
    },
    query: QUERY_DISTRIBUTIONS,
    variables: VARIABLES_DISTRIBUTIONS({
      byIDs: distIdsToSearch,
      first: PAGE_SIZE,
    }),
  });

  const queryState = useQueryStates({
    data: packList,
    enforceData: true,
    states: [distributionState, packListState],
  });

  useEffect(() => {
    if (
      (advancePage || packs.length === 0) &&
      queryState === FS.SUCCESS &&
      !isDone
    ) {
      const packsPage = packList.slice(
        (page - 1) * PAGE_SIZE,
        page * PAGE_SIZE,
      );
      const mergedPacks =
        distributions && packsPage && packsPage.length > 0
          ? mergePackDistributions(packsPage, distributions)
          : [];
      const updatedPacks = [...packs, ...mergedPacks];
      setPacks(updatedPacks);
      setPage(page + 1);
      setAdvancePage(false);
      if (updatedPacks.length === packList.length) {
        setIsDone(true);
      }
    }
  }, [
    distributions,
    queryState,
    page,
    packs,
    setPacks,
    isDone,
    numPages,
    advancePage,
    packList,
  ]);

  const handleNextPage = () => {
    setDistIdsPage(distIdsPage + 1);
    setAdvancePage(true);
  };

  return {
    advancePage: handleNextPage,
    hasNextPage: !isDone,
    packs,
    page,
    queryState,
  };
};
